
require('./bootstrap');
require('bootstrap');
require('bootstrap-modal');
require('bootstrap-datepicker');
require('pc-bootstrap4-datetimepicker');
require('datatables.net-bs4');
require('jquery-mask-plugin');


global.$ = global.jQuery = require('jquery');
window.Dropzone = require('dropzone');
window.Compressor = require('compressorjs');
Dropzone.autoDiscover = false;

import features from "./features";
import customer from "./customer";
import auth from "./auth";
import masks from "./masks";
import event from "./admin/event";
import Slider from "./slider";
import faq from "./faq";
import RunningLine from "./components/RunningLine";
import { SimpleSectionSwitcher } from "./components/SimpleSectionSwitcher";
import emailNotifications from './email-templating/email-notifications';
import homePage from "./static-pages/home-page";


$(document).ready(function () {
    customer.init();
    features.init();
    faq.init();
    auth.init();
    masks.init();
    event.init();
    emailNotifications.init();
    homePage.init();
    Slider.init();
    SimpleSectionSwitcher.init();
    RunningLine.init();
});
